import { ImageFormat } from '@extTypes/image/format';
import api from '../baseAPIs/shopify';
import { ImageSignedUrlResponse } from '@extTypes/image/imageS3';

export const getTemporaryImageSignedUrl = async (format: ImageFormat): Promise<ImageSignedUrlResponse> => {
    const response = await api.get('image/temp/url', {
        params: {
            format: format
        }
    });
    return response.data;
};

export const getProductSignedImageUrl = async (format: ImageFormat): Promise<ImageSignedUrlResponse> => {
    const response = await api.get('image/product/url', {
        params: {
            format: format
        }
    });
    return response.data;
};
